export default __webpack_public_path__ + "static/media/1931.329ed13d.png";